export function imageExt(image) {
  let uriParts = image.fileName.split('.');
  let extension = uriParts[uriParts.length - 1].toLowerCase();
  return Promise.resolve(extension);
}
